/** @jsx jsx */
import { Button, Flex, jsx, Text } from 'theme-ui'

const Tabs = ({ ariaLabel, currentOption, options, setOption }) => {
  return (
    <Flex sx={{ justifyContent: 'center' }}>
      {options.map((option, index) => (
        <Button
          variant="reset"
          key={index}
          aria-label={`${ariaLabel}: ${option.title}`}
          onClick={() => setOption(option)}
          mx="4px"
          px={[3, null, null, 5]}
          pb={2}
          sx={{
            borderBottom: '3px solid',
            borderBottomColor:
              currentOption.title === option.title
                ? 'brandTertiary'
                : 'greyLight',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': {
              borderBottomColor: 'brandTertiary',
            },
          }}
        >
          <Text as="p" variant="callout1">
            {option.title}
          </Text>
        </Button>
      ))}
    </Flex>
  )
}

export default Tabs
